import React, { useContext } from 'react';

import { QaIdentifier, useQa } from 'hooks/useQa';

import { CommunicationContext } from 'utility/Provide/Context/PageContext';

import { Airport } from 'types/legacy/LastSearch';
import { Iata } from 'types/Search/airport';

import { getRecommendedIataList } from '../../__helper/airport';
import {
    Country as CountryType,
    RecommendationProps,
    Region,
} from '../../types';
import styles from '../Airport.module.scss';

import Country from './Country';
import LastSearch from './LastSearch';
import RecommendationList from './Recommendation';

interface InitialListProps {
    onLastSearchesClick: (entry: Airport) => void;
    onCountryClick: (entry: CountryType, isChecked: boolean) => void;
    onRegionClick: (
        country: CountryType,
        isChecked: boolean,
        region: Region
    ) => void;
    onClick: (entry: Iata) => void;
}

type AirportRecommendations = {
    airportRecommendations?: RecommendationProps[];
};
const InitialList = ({
    onLastSearchesClick,
    onRegionClick,
    onCountryClick,
    onClick,
}: InitialListProps) => {
    const context = useContext(CommunicationContext);
    const qaAttr = useQa(QaIdentifier.Search_Form_Airport_Layer_Initial);
    const lastSearches =
        context.components.travel?.lastAirportsDataService?.getVariables()
            .parsedJsonDataTemp.items?.airports ?? [];

    return (
        <div className={styles.ScrollContainer} {...qaAttr}>
            {lastSearches.length ? (
                <LastSearch
                    entries={lastSearches}
                    onClick={onLastSearchesClick}
                />
            ) : (
                <RecommendationList
                    entries={getRecommendedIataList(
                        context.components.backendInformationFunc.getData<AirportRecommendations>(
                            'searchFormDefaults'
                        ).airportRecommendations ?? []
                    )}
                    onClick={onClick}
                />
            )}
            <Country
                onRegionClick={onRegionClick}
                onCountryClick={onCountryClick}
                onClick={onClick}
            />
        </div>
    );
};

export default InitialList;
